import React from "react"
import { Link } from "gatsby"
import { Button } from "nzk-react-components"
import styled from "styled-components"
import RequestEmailButton from "components/Buttons/RequestEmailButton"
import useLoginModal from "components/LoginModal/useLoginModal"
import LocalButton from "../../UI/Button"
import scrollToPlansSection from "../actions/scrollToPlansSection"
import scrollToTeacherCTA from "../actions/scrollToTeacherCTA"

const ACTIONS = {
  SCROLL_TO_PLANS: scrollToPlansSection,
  SCROLL_TO_TEACHER_CTA: scrollToTeacherCTA,
  LOGIN_POPUP: () => { },
}

export interface StrapiButtonProps extends Strapi.StrapiButton {
  size?: "small" | "x-small" | "regular" | "large" | "x-large" | undefined
  theme: "confirm" | "primary" | "the-pink" | "purple"
  className?: string
}

const SubmitButton = styled.div`
padding: 12px 12px;
border-radius: 12px;
cursor: pointer;
user-select: none;
font-size: 1.2rem;
font-family: "Rammetto One", cursive;
color: #fff;
border-radius: 14px;
background-color: rgba(255,255,255,0.12);
border: 1px solid rgba(255,255,255,0.15);
width: 100%;
outline: none;
-webkit-transition: all 0.25s ease;
transition: all 0.25s ease;
box-sizing: border-box;
-webkit-backdrop-filter: blur(4px);
backdrop-filter: blur(4px);
}

&:focus, &:active, &:hover {

  border-color: #E839B2;
  background-color: rgba(255,255,255,0.18);
  box-shadow: 0 0 0 3px rgba(232,57,178,0.15);
}
`

const StrapiButton = (props: StrapiButtonProps) => {
  const loginModal = useLoginModal()

  const onClick =
    props.action && ACTIONS[props.action]
      ? () => {
        ACTIONS[props.action!]()
      }
      : undefined

  if (props.action === "LOGIN_POPUP") {
    return (
      <>
        {loginModal}
        <Button
          className={props.className}
          size={props.size}
          theme={props.theme}
          onClick={() => {
            loginModal[1]()
          }}
        >
          {props.value}
        </Button>
      </>
    )
  }

  const button =
    typeof window !== "undefined" ? (
      <Button className={props.className} size={props.size} theme={props.theme} onClick={onClick}>
        {props.value}
      </Button>
    ) : (
      // @ts-ignore
      <LocalButton className={props.className} size={props.size} theme={props.theme} onClick={onClick}>
        {props.value}
      </LocalButton>
    )

  if (props.requestDetails) {
    return (
      <RequestEmailButton
        submitButton={
          <SubmitButton >
            Submit
          </SubmitButton>
        }
        reason={props.requestDetailsReason || ""}
        onSubmit={() => {
          if (props.targetUrl) {
            window.open(props.targetUrl)
          }
        }}
      >
        {props.value}
      </RequestEmailButton>
    )
  }

  if (props.targetUrl) {
    return <Link className={props.className} to={props.targetUrl}>{button}</Link>
  }
  return button
}

StrapiButton.defaultProps = {
  size: "regular",
}

export default StrapiButton
